import axios from '../../axios-dashboard'

import * as actionTypes from './actionTypes'

export const loginStart = () => {
    return {
        type: actionTypes.LOGIN_START
    }
};

export const loginSuccess = (token, company, email, permissions, hasGcp, gcpOnly) => {
    if (hasGcp === undefined) {
        return {
            type: actionTypes.LOGIN_SUCCESS,
            token: token,
            company: company,
            email: email,
            permissions: permissions,
        }
    }
    return {
        type: actionTypes.LOGIN_SUCCESS,
        token: token,
        company: company,
        email: email,
        permissions: permissions,
        hasGcp: hasGcp,
        gcpOnly: gcpOnly,
    }
};

export const loginFail = (error, email) => {
    return {
        type: actionTypes.LOGIN_FAIL,
        error: error,
        email: email,
    }
};

export const samlLoginStart = () => {
    return {
        type: actionTypes.SAML_LOGIN_START,
    }
}

export const samlLoginSuccess = (token, company, email, permissions, hasGcp, gcpOnly) => {
    if (hasGcp === undefined) {
        return {
            type: actionTypes.SAML_LOGIN_SUCCESS,
            token: token,
            company: company,
            email: email,
            permissions: permissions,
        }
    }
    return {
        type: actionTypes.SAML_LOGIN_SUCCESS,
        token: token,
        company: company,
        email: email,
        permissions: permissions,
        hasGcp: hasGcp,
        gcpOnly: gcpOnly,
    }
}

export const samlLoginFail = (error, email) => {
    return {
        type: actionTypes.SAML_LOGIN_FAIL,
        error: error,
        email: email,
    }
}

export const logoutStart = () => {
    return {
        type: actionTypes.LOGOUT_START
    }
};

export const logoutSuccess = () => {
    return {
        type: actionTypes.LOGOUT_SUCCESS
    }
};

export const logout = (token) => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("expirationDate");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("company");
    sessionStorage.removeItem("beforeRefreshPage");

    return dispatch => {
        dispatch(logoutStart());
        const url = "/logout";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url).then(response => {
            dispatch(logoutSuccess())
        }).catch(err => {
            dispatch(logoutSuccess())
        })
    }
};

export const removeLocalStorage = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("expirationDate");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("company");
    sessionStorage.removeItem("beforeRefreshPage");
};

export const checkTokenValidity = (expiration) => {
    let token = sessionStorage.getItem("token");
    if (!token) {
        return
    }
    return dispatch => {
        setTimeout(() => {
            dispatch(logout(token))
        }, expiration)
    }
};

export const login = (email, password) => {
    return dispatch => {
        dispatch(loginStart());
        const loginData = {
            email: email,
            password: password
        };
        const url = "/login";
        axios.post(url, loginData)
            .then(response => {
                const expiration = new Date(new Date().getTime() + 24 * 3600 * 1000);

                sessionStorage.setItem("token", response.data.token);
                sessionStorage.setItem("email", email);
                sessionStorage.setItem("company", response.data.company);
                sessionStorage.setItem("expirationDate", expiration);
                dispatch(loginSuccess(response.data.token, response.data.company, email, response.data.permissions, response.data.hasGcp, response.data.gcpOnly));
                dispatch(checkTokenValidity(1 * 3600 * 1000));
            })
            .catch(err => {
                dispatch(loginFail(err.response.data.error, email));
            })
    }
};

export const samlLogin = (email, sessionId) => {
    return dispatch => {
        dispatch(samlLoginStart());
        const loginData = {
            email: email,
            sessionId: sessionId
        }

        const url = "/saml-login";
        axios.post(url, loginData)
            .then(response => {
                const expiration = new Date(new Date().getTime() + 24 * 3600 * 1000);

                sessionStorage.setItem("token", response.data.token);
                sessionStorage.setItem("email", email);
                sessionStorage.setItem("company", response.data.company);
                sessionStorage.setItem("expirationDate", expiration);
                dispatch(samlLoginSuccess(response.data.token, response.data.company, email, response.data.permissions, response.data.hasGcp, response.data.gcpOnly));
                dispatch(checkTokenValidity(1 * 3600 * 1000));
            }).catch(err => {
            dispatch(samlLoginFail(err.response.data.error, email));
        })

    }
}

export const checkLoginState = () => {
    return dispatch => {
        const token = sessionStorage.getItem("token");
        if (!token) {
            dispatch(removeLocalStorage())
        } else {
            const expDate = sessionStorage.getItem("expirationDate")
            if (expDate) {
                const expiration = new Date(expDate);
                if (expiration > new Date()) {
                    const email = sessionStorage.getItem("email");
                    const company = sessionStorage.getItem("company");
                    dispatch(loginSuccess(token, company, email));
                    dispatch(checkTokenValidity((expiration.getTime() - new Date().getTime())))
                } else {
                    dispatch(logout(token))
                }
            } else {
                dispatch(logout(token))
            }
        }
    }
};
